import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toNullableLocaleDateTimeString } from '../utilities';
import { QuoteRequestResponse } from '../apiModels/quoteRequestResponse';
import { quoteContactMethods } from '../apiModels/quoteContactMethod';

export default function QuoteRequestDetailsModal(props: { show: boolean, setShow: (show: boolean) => void, quoteRequest: QuoteRequestResponse }) {
    const preferredContactMethod = props.quoteRequest.contactMethod === quoteContactMethods.email ? 'Email' : 'Phone';
    const dateCreated = new Date(props.quoteRequest.createdDate);

    return (
        <>
            <Modal show={props.show} onHide={() => props.setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Quote Request Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-6">
                            <label className="fw-bold">First Name</label>
                            <p>{props.quoteRequest.firstName}</p>
                        </div>

                        <div className="col-6">
                            <label className="fw-bold">Last Name</label>
                            <p>{props.quoteRequest.lastName}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <label className="fw-bold">Email</label>
                            <p>{props.quoteRequest.email}</p>
                        </div>

                        <div className="col-6">
                            <label className="fw-bold">Phone Number</label>
                            <p>{props.quoteRequest.phone}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <label className="fw-bold">Company Name</label>
                            <p>{props.quoteRequest.companyName}</p>
                        </div>

                        <div className="col-6">
                            <label className="fw-bold">Preferred Contact Method</label>
                            <p>{preferredContactMethod}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <label className="fw-bold">Shipment Details</label>
                            <p>{props.quoteRequest.shipmentDetails}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <label className="fw-bold">Date Created</label>
                            <p>{toNullableLocaleDateTimeString(props.quoteRequest.createdDate)}</p>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className='btn btn-default'
                        onClick={() => props.setShow(false)}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export const ButtonLoadingSpinner = () => {
    return (
        <div className="spinner-border spinner-border-sm text-default" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    );
};